import { render, staticRenderFns } from "./TableClassification.vue?vue&type=template&id=7b79b06f&scoped=true&"
import script from "./TableClassification.vue?vue&type=script&lang=js&"
export * from "./TableClassification.vue?vue&type=script&lang=js&"
import style0 from "./TableClassification.vue?vue&type=style&index=0&id=7b79b06f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b79b06f",
  null
  
)

export default component.exports